import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { VoucherReceiptComponent } from './voucher-receipt.component';
import { LightImageModule } from '../light-image/light-image.module';
import { SvgQrcodeModule } from '../svg-qrcode/svg-qrcode.module';

// for meee

@NgModule({
    declarations: [VoucherReceiptComponent],
    imports: [
        CommonModule,
        FormsModule,
        LightImageModule,
        SvgQrcodeModule
    ],
    exports: [
        VoucherReceiptComponent
    ]
})
export class VoucherReceiptModule { }
